import * as React from 'react';
import { flow, get, head } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { InjectedFormProps } from 'redux-form';
import { IMtaState } from '../../../../../../services/mta/models';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import CancelHeader from '../CancelPolicy/components/CancelHeader';
import { IQuoteState } from '../../../../../../services/quote/models';
import ObjectionHandling from '../CancelPolicy/components/ObjectionHandling';
import Loading from '../../../../../../components/Loading';
import { withJob } from 'react-jobs';
import { actions as brandingActions } from '../../../../../../services/branding/reducer';
import { IBrandingActions, IBrandingState } from '../../../../../../services/branding/models';

interface IMTACancelRenewalProps extends InjectedFormProps<any> {
  match: any;
  mta: IMtaState;
  quote: IQuoteState;
  dispatch: any;
  actions: {
    push: (route: string) => void;
    branding: IBrandingActions;
  };
  branding: IBrandingState;
}

class CancelRenewal extends React.Component<IMTACancelRenewalProps, any> {

  private handleNext = () => {
    const { actions } = this.props;
    actions.push(`/account/make-a-change/renewal-cancel-reason`);
  }

  private renderText = () => {
    const { mta } = this.props;
    const policyHolderName = get(head(get(mta, 'selectedPolicy.metadata.adults', [])), 'first_name');

    return (
      <div className={'cancel-text-container'}>
        <div>
          {policyHolderName + ', we\'re sorry to hear that you want to cancel your renewal.'}
        </div>

        <div className={'mt-15'} style={{ textDecoration: 'underline' }}><b>Do you know about continuous cover?</b></div>
        <div><b>1-in-4 of the claims we pay are because a trip has been cancelled or delayed before it starts due to
          unexpected events!*</b></div>

        <div className={'mt-15'}>Renewing your policy will protect you from unexpected cancellations and delays on any
          holidays you take in the next 12 months, even if you haven’t booked them yet.**
        </div>

        <div className={'mt-15'}>If you cancel today, any future trips you have booked will no longer be covered.</div>

        <div style={{ textAlign: 'center', marginTop: '15px' }}>Still want to cancel?</div>

        <div style={{ textAlign: 'right', marginTop: '35px' }}>
          <p style={{ fontStyle: 'italic', color: 'grey', fontSize: '12px' }}>* based on claims settled in 2023</p>
          <p style={{ fontStyle: 'italic', color: 'grey', fontSize: '12px' }}>** within cover limits</p>
        </div>
      </div>
    )

  }

  render() {
    const { mta, quote } = this.props;
    const policyId = get(mta, 'selectedPolicy.id');
    const renewal = get(quote, 'application')
    const leadTraveller = head(renewal.travellers)
    return (
      <div style={{ maxWidth: '800px', margin: '30px auto 0 auto' }}>
        <CancelHeader
          title={`Cancel Renewal Quote - ${get(renewal, 'quoteReference')}`}
          leadTraveller={leadTraveller}
        />
        {this.renderText()}
        <ObjectionHandling
          policyId={policyId}
          handleNext={this.handleNext}/>
      </div>
    );
  }
}

export default flow([
  withJob({
    work: (props: IMTACancelRenewalProps) => {
      const promises = [];
      let salesChannel = props.quote.application.salesChannel;
      const pos = salesChannel.search('-renewal');
      if (pos > -1) {
        salesChannel = salesChannel.substr(0, pos);
      }
      salesChannel += '-renewal';

      promises.push(props.actions.branding.reLoadChannel(salesChannel));

      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        mta: state.mta,
        quote: state.quote,
        branding: state.branding
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(CancelRenewal);
